import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import Loading from '@/components/Core/Loading'
import ApiManager from '@/utils/ApiManager'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Validator from '@/utils/Validator'

export default {
  name: 'ServiceDetail',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String
  },
  data () {
    return {
      loading: true,
      processing: false
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.resetDetail()
  },
  computed: {
    ...mapState({
      categoryName: state => state.service.categoryName,
      // form
      values: state => state.serviceDetail.values,
      // confirm
      confirmKey: state => state.confirm.key,
      confirmAccepted: state => state.confirm.accept
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      getValue: 'serviceDetail/getValue'
    }),

    // list
    statusList () {
      return Constants.Status.sort(Utility.sortByKey('index', true))
    },

    // input
    inpServiceName: {
      get () {
        return this.values.inpServiceName
      },
      set (value) {
        this.setInputValue({
          key: 'inpServiceName',
          value: value
        })
      }
    },
    inpStatus: {
      get () {
        return this.values.inpStatus
      },
      set (value) {
        this.setInputValue({
          key: 'inpStatus',
          value: value
        })
      }
    },

    // validate
    inpServiceNameIsValid () {
      return Validator.validText(this.inpServiceName)
    },
    formIsValid () {
      return this.inpServiceNameIsValid
    },
    disablePostButton () {
      return !this.formIsValid
    }
  },
  watch: {
    confirmAccepted: function (to) {
      console.log('confirmKey : ', this.confirmKey)
      // 登録
      if (this.confirmKey === 'modify') {
        if (to) this.postData()
      }
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showConfirm: 'confirm/show',
      showToast: 'toast/show',
      loadModel: 'serviceDetail/loadModel',
      resetDetail: 'serviceDetail/reset'
    }),
    ...mapMutations({
      setValues: 'serviceDetail/setValues',
      setInputValue: 'serviceDetail/setInputValue'
    }),

    init () {
      this.loading = true

      //TODO
      let serviceParams = {
        serviceUuid: this.serviceId
      }

      // データ読出し
      this.loadModel({
        targetId: this.serviceId,
        serviceParams: serviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    // ファイル登録
    confirmData() {
      this.showConfirm({
        key: 'modify',
        title: 'サービス基本情報の変更',
        body: 'このサービスの基本情報を変更しますか？'
      })
    },
    postData () {
      this.processing = true

      //
      let parameters = {
        serviceUuid: this.serviceId,
        request: {
          serviceName: this.inpServiceName,
          serviceStatus: this.inpStatus
        }
      }
      console.log('register data', parameters)

      // 登録
      ApiManager.request(
        ['service'],
        ['v1ServicePatch'],
        [parameters])
        .then(res => {
          this.processing = false
          let status = Utility.parseResponse(res)

          if (status.result) {
            // toast
            this.showToast({
              title: this.categoryName + '情報の変更',
              body: this.categoryName + '情報を変更しました。'
            })

          } else if (status.error) {
            // エラーメッセージ表示
            this.showError(res)
          } else {
            // アプリケーションエラー表示
            this.showError(null)
          }
          
        })
        // eslint-disable-next-line
        .catch(error => {
          this.processing = false
          this.showError(null)
        })
    }
  }
}